module.exports = __webpack_public_path__ + "img/fission-func1.8f67c723.jpg";